module.exports = __webpack_public_path__ + "../static/img/_logo.11092e47.png";